import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Graphic, MarkdownHTML } from '../../components';
import { paths } from '../../routes';
import env from '../../utils/env';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="h-full bg-pos-background flex flex-col">
      <header className="bg-white text-pos-black underline-header fixed inset-x-0 top-0 z-50 flex-none min-h-[60px]">
        <nav className="px-5">
          <div className="flex items-center justify-between h-[60px]">
            <div className="flex items-center">
              <Link
                to={paths.DASHBOARD_URL_PATH}
                className="shrink-0 font-semibold text-xl"
              >
                SwiftInFlow
              </Link>
            </div>

            <div className="" />
          </div>
        </nav>
      </header>
      <main className="relative flex-auto pt-20 tablet:pt-24 px-7 tablet:px-10 desktop:px-16 h-full w-full">
        <div className="relative pt-8 tablet:pt-14 pb-14 flex flex-col justify-center items-center">
          <h3 className="text-[#8f7319] text-xl font-medium mb-2">
            Hmm. Are we lost? 🤔
          </h3>
          <span>
            <pre className="inline-flex text-base whitespace-pre-wrap text-center w-full">
              {`Looks like you're lost. Don't worry lets take you home.`}
            </pre>
          </span>

          <Graphic
            className="w-[250px] tablet:w-[550px] transform rotate-3 transition hover:scale-105 duration-700 ease-in-out hover:rotate-3"
            id="graphic404"
          />

          <Button
            label="Go Home"
            onClick={() => navigate(paths.DASHBOARD_URL_PATH)}
            className="!px-2 mt-10 !shrink-0"
          />

          <MarkdownHTML
            className="text-pos-black text-xbase mt-6 text-center"
            content={`If this persists, please reach out to our [support team.](${paths.LANDING_SUPPORT_URL_PATH})`}
          />
        </div>
      </main>
    </div>
  );
}

export default NotFound;
